/** @format */

export class Brand {
  id: string;
}
